export default function Concept() {
  return (
    <section className="py-32 bg-gradient-to-b from-[#231D17] to-[#2A2318]">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#E5C478] mb-16 text-center tracking-wide">
            The Concept
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <p className="text-lg md:text-xl text-[#F0E1C2]/90 leading-relaxed">
                The GodPadel™ is a premium indoor padel club concept designed as more than just courts. It is a social and sporting destination where performance, atmosphere, and lifestyle meet.
              </p>

              <div className="w-20 h-1 bg-[#B78A44]"></div>

              <p className="text-base md:text-lg text-[#F0E1C2]/80 leading-relaxed">
                Every detail has been considered to create an environment that reflects the sophistication and passion of the sport itself. This is where excellence meets elegance.
              </p>
            </div>

            <div className="relative h-96 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/661dc256f1eb72c15bcf4baf0602dc8e.jpg"
                alt="Premium Padel Equipment"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
